// Angular
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'fileType',
  standalone: true
})
export class FileTypePipe implements PipeTransform {
  imageFileTypes = ['png', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'svg']
  videoFileTypes = ['webm', 'mkv', 'avi', 'mp4'];
  pdfFileTypes = ['pdf'];
  fileTypes = ['zip', 'rar'];

  constructor(protected _sanitizer: DomSanitizer) { }

  transform(
    value: any, args?: any
  ): string {
    let type = value?.split('.').pop();
    if (this.imageFileTypes.indexOf(type) !== -1)
      return 'image';
    else if (this.videoFileTypes.indexOf(type) !== -1)
      return 'video';
    else if (this.pdfFileTypes.indexOf(type) !== -1)
      return 'pdf';
    else if (this.fileTypes.indexOf(type) !== -1)
      return 'file';

  }
}
